export default {
	init: function(Swiper, Navigation) {

        this.initSlider(Swiper, Navigation);

        const body = document.querySelector('body')
        body.addEventListener('dom:updated', () => {
            this.initSlider(Swiper, Navigation);
        })
        
	},
    initSlider: function(Swiper, Navigation){
        const sliderEls = document.querySelectorAll('.js-pageHeroSlider-swiper')

        if (sliderEls.length) {
            sliderEls.forEach(slider => {

                const sliderBlock = slider.closest('.js-pageHeroSlider')
                const prevEl = sliderBlock.querySelector('.js-pageHeroSlider-swiper-prev')
                const nextEl = sliderBlock.querySelector('.js-pageHeroSlider-swiper-next')
                
                const sliderInstance = new Swiper(slider, {
                    slidesPerView: 1,
                    // speed: 600,
                    spaceBetween: 30,
                    modules: [Navigation],
                    navigation: {
                        prevEl: prevEl,
                        nextEl: nextEl
                    },
                    // breakpoints: {
                    //     700: {
                    //       slidesPerView: 2,
                    //     }
                    // },
                })

                const controlsIndexEl = sliderBlock.querySelector('.js-controls-current')

                if (!controlsIndexEl) { 
                    console.info("Can't find controls in slider element")
                } else {
                    sliderInstance.on('slideChange', () => {
                        controlsIndexEl.textContent = sliderInstance.activeIndex + 1
                    })
                }

            })
        }
    }
}